import React from "react";
import "../styles/AboutHero.css";
import heroImage from "../../assets/image1.png";

const AboutHero = () => {
  return (
    <section className="about-hero-section">
      <div className="about-hero-container">

        {/* LEFT CONTENT */}
        <div className="about-hero-content">
          <span className="about-label">About Us</span>

          <h1>
            Delivering Reliable <br />
            <span>Logistics Solutions</span> Every <br />
            Time
          </h1>

          <p>
            SPARSH CARGO PRIVATE LIMITED (SCPL) is a professionally managed
            logistics company with over 15 years of experience in the express
            and supply chain industry.
          </p>

          <p>
            We provide end-to-end logistics solutions with a strong focus on
            reliability, speed, and customer satisfaction.
          </p>

          <ul>
            <li>
              15+ years of experience delivering excellence, reliability, and
              customer-focused logistics services.
            </li>
          </ul>

          <div className="about-hero-footer">
            <button className="primary-btn">Contact Us</button>

            <div className="customer-box">
              <div className="avatars">
                <img src="https://i.pravatar.cc/40?img=11" alt="" />
                <img src="https://i.pravatar.cc/40?img=12" alt="" />
                <img src="https://i.pravatar.cc/40?img=13" alt="" />
                <img src="https://i.pravatar.cc/40?img=14" alt="" />
              </div>
              <div>
                <strong>5K+</strong>
                <span>Satisfied Customers</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="about-hero-image">
          <img src={heroImage} alt="SCPL Logistics" />

          <div className="experience-badge">
            <span className="years">15</span>
            <span>
              Years Of <br /> Experience
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutHero;
